import React from 'react';
import { observer } from 'mobx-react';
import ImportCsvService from '../services/ImportCsvService';
import ImportCsvDialog from './ImportCsvDialog';

const ImportCsvDialogContainer = () => {
  return (
    <ImportCsvDialog
      isOpen={ImportCsvService.isOpen}
      onClose={ImportCsvService.handleCloseDialog}
      onChange={ImportCsvService.form.setValue}
      onUpload={ImportCsvService.handleUpload}
      onImport={ImportCsvService.handleImport}
      onDiscardPreview={ImportCsvService.handleDiscardPreview}
      setScene={ImportCsvService.setScene}
      currentScene={ImportCsvService.currentScene}
      values={ImportCsvService.form.getValues()}
      errors={ImportCsvService.form.errors}
      submitting={false || ImportCsvService.loading}
    />
  );
};

export default observer(ImportCsvDialogContainer);
